import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Button from '../Button';
import ThemeToggle from '../theme/ThemeToggle';
import '@fortawesome/fontawesome-free/css/all.min.css';

interface AdminHeaderProps {
  onOpenSectionsMenu: () => void;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ onOpenSectionsMenu }) => {
  const { user, logout } = useAuth();

  return (
    <header className="header sticky-top bg-dark text-white">
      <nav className="navbar navbar-expand-lg navbar-dark">
        <div className="container-fluid">
          <Button
            type="button"
            className="btn btn-link text-white p-2 me-1 d-md-none"
            onClick={onOpenSectionsMenu}
            aria-label="Admin bölümlerini aç"
          >
            <i className="fas fa-bars fa-lg" />
          </Button>
          <Link className="navbar-brand fw-bold me-auto" to="/admin-panel">
            <i className="fas fa-laptop me-2" />
            <span className="d-none d-sm-inline">SadeceBilgisayar Admin</span>
            <span className="d-sm-none">Admin</span>
          </Link>
          <Button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#adminNavbar"
            aria-controls="adminNavbar"
            aria-expanded="false"
            aria-label="Hesap menüsünü aç/kapat"
          >
            <span className="navbar-toggler-icon" />
          </Button>
          <div className="collapse navbar-collapse" id="adminNavbar">
            <ul className="navbar-nav ms-auto align-items-lg-center">
              <li className="nav-item me-lg-3">
                <ThemeToggle className="text-white fs-5" />
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle d-flex align-items-center"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span>{user?.name || 'Admin'}</span>
                </a>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <Link className="dropdown-item" to="/profil">
                      <i className="fas fa-user me-2" />
                      Profilim
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/">
                      <i className="fas fa-home me-2" />
                      Siteye Dön
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        logout();
                      }}
                    >
                      <i className="fas fa-sign-out-alt me-2" />
                      Çıkış Yap
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default AdminHeader;
